var $0cb8a48856b234ae$exports = {};
$0cb8a48856b234ae$exports = {
    "more": `\u{66F4}\u{591A}\u{9879}\u{76EE}`
};


export {$0cb8a48856b234ae$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
